import React from 'react';
import { makeStyles } from '@material-ui/core';
import colorForWorkscale from '../../workscale/colorForWorkscale';

const useStyles = makeStyles(() => ({
    workloadScale: {
        position: 'fixed',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#FFFFFFFA',
        borderRadius: 30,
        boxShadow: '0 8px 50px rgba(0, 0, 0, 0.16)',
        padding: '10px 13px',
        zIndex: 1052,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        border: '1px solid rgba(0, 0, 0, 0.08)',
        '@media (max-width: 768px)': {
            display: 'none',
        },
    },
    workloadItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 14,
        fontWeight: 500,
        color: '#333',
        paddingRight: 12,
        borderRight: '1px solid rgba(0, 0, 0, 0.08)',
        '&:last-child': {
            borderRight: 'none',
            paddingRight: 5,
        },
    },
    workloadDot: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 11,
        fontWeight: 700,
        color: 'white',
    },
    workloadText: {
        whiteSpace: 'nowrap',
    },
}));

interface WorkloadScaleProps {
    className?: string;
}

const WorkloadScale: React.FC<WorkloadScaleProps> = ({ className }) => {
    const classes = useStyles();

    const workloadLevels = [
        { level: 0, displayNumber: '1.0', text: 'Available' },
        { level: 1, displayNumber: '2.0', text: 'Some availability' },
        { level: 2, displayNumber: '3.0', text: 'Busy' },
        { level: 3, displayNumber: '4.0', text: 'Seriously busy' },
    ];

    return (
        <div className={`${classes.workloadScale} ${className || ''}`}>
            {workloadLevels.map((item) => (
                <div key={item.level} className={classes.workloadItem}>
                    <div
                        className={classes.workloadDot}
                        style={{ backgroundColor: colorForWorkscale(item.level) }}
                    >
                        {item.displayNumber}
                    </div>
                    <span className={classes.workloadText}>{item.text}</span>
                </div>
            ))}
        </div>
    );
};

export default WorkloadScale; 